import Form from '@js/components/form';

const Sage = window.Sage;
const grecaptcha = window.grecaptcha;

export default {
  init() {
    this.events();
  },

  events() {
    $('.dropzone input').on('change', (e) => {
      const input = e.currentTarget;
      const label = $(input).siblings('.dropzone__box');

      if (0 === input.files.length) {
        label.html(
          '<p>Ievelciet vai <span class="text-blue">izvēlieties failus</span></p>'
        );
        return;
      }

      let fileContent = '<p>';

      if (1 < input.files.length) {
        fileContent += 'Izvēlētie faili:';
      } else {
        fileContent += 'Izvēlētais fails:';
      }

      for (let index = 0; index < input.files.length; index++) {
        const file = input.files[index];

        fileContent += `<br><span class="text-blue">${file.name}</span>`;
      }

      fileContent += '</p>';

      label.html(fileContent);
    });

    $('form#apply').on('submit', (e) => {
      e.preventDefault();

      const formEl = $(e.currentTarget);

      if (formEl.hasClass('loading')) {
        return;
      }

      formEl.addClass('loading');
      formEl.find('.form-field__input').removeClass('error');
      formEl.find('.form-field__error').html('');
      formEl.find('.form__success').slideUp();
      formEl.find('.form__error').slideUp();

      if (Form.validate(formEl)) {
        this.recaptcha();
      } else {
        formEl.removeClass('loading');
      }
    });
  },

  recaptcha() {
    const _self = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute(Sage.recaptcha_site_key, { action: 'submit' })
        .then(function (token) {
          _self.submitForm(token);
        });
    });
  },

  submitForm(token) {
    const _self = this;
    const formEl = $('form#apply');

    const formData = new FormData(formEl[0]);
    formData.append('token', token);

    $.ajax({
      url: formEl.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: (resp) => {
        if (resp.success) {
          formEl[0].reset();
          formEl.find('.dropzone input').trigger('change');
          formEl.find('.form__success').slideDown();
        } else {
          _self.handleErrors(resp.data.errors);
          formEl.find('.form__error').slideDown();
        }
      },
      error: () => {
        formEl.find('.form__error').slideDown();
      },
      complete: () => {
        formEl.removeClass('loading');
      },
    });
  },

  handleErrors(errors) {
    if (!(0 < Object.keys(errors).length)) {
      return;
    }

    const formEl = $('form#apply');

    formEl.find('.form-field.error').removeClass('error');
    formEl.find('.form-field__error').html('');

    Object.keys(errors).forEach((key) => {
      const input = formEl.find(`[name="${key}"]`);

      input.addClass('error');
      const errorEl = input.closest('.form-field').find('.form-field__error');

      errorEl.html(errors[key]);
    });
  },
};
